import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cellRender',
})
export class CellRenderPipe implements PipeTransform {
  transform<T extends Record<PropertyKey, unknown>>(
    element: T,
    key: string | number | symbol,
    render?: (value: T) => string
  ): string {
    if (!render) return String(element[key] ?? '');
    return render(element);
  }
}
